import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["mobilePanel"]
  static values = {
    isOpen: { type: Boolean, default: false }
  }

  connect() {
    console.log("Filter form controller connected")
    // Force initial state
    this.closeMobilePanel()
  }

  disconnect() {
    this.closeMobilePanel()
  }

  toggleMobileFilters(event) {
    console.log("Toggle clicked")
    // Always prevent default and stop propagation for toggle button
    event?.preventDefault()
    event?.stopPropagation()
    
    if (!this.isOpenValue) {
      this.openMobilePanel()
    }
  }

  closePanel(event) {
    console.log("Close clicked")
    // Only prevent default for explicit close actions
    event?.preventDefault()
    this.closeMobilePanel()
  }

  openMobilePanel() {
    console.log("Opening mobile panel")
    this.isOpenValue = true
    requestAnimationFrame(() => {
      this.mobilePanelTarget.classList.remove("translate-y-full")
      document.body.classList.add("overflow-hidden", "mobile-filters-open")
    })
  }

  closeMobilePanel() {
    console.log("Closing mobile panel")
    this.isOpenValue = false
    requestAnimationFrame(() => {
      this.mobilePanelTarget.classList.add("translate-y-full")
      document.body.classList.remove("overflow-hidden", "mobile-filters-open")
    })
  }

  submitOnChange(event) {
    console.log("submitOnChange triggered", { event })
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    this.timeout = setTimeout(() => {
      console.log("Submit timeout executed")
      const form = event.target.closest('form')
      console.log("Found form:", { form })
      
      if (form) {
        const formData = new FormData(form)
        formData.append('is_filter_change', 'true')
        const queryString = new URLSearchParams(formData).toString()
        console.log("Submitting form with data:", { queryString })
        
        fetch(`${form.action}?${queryString}`, {
          headers: {
            'Accept': 'text/vnd.turbo-stream.html',
            'Turbo-Frame': 'search-results'
          }
        })
        .then(response => {
          console.log("Received response:", { status: response.status })
          return response.text()
        })
        .then(html => {
          console.log("Processing response HTML")
          const parser = new DOMParser()
          const doc = parser.parseFromString(html, 'text/html')
          
          // Update the entire results content
          const newResultsContent = doc.querySelector('#results-content')
          const currentResultsContent = document.querySelector('#results-content')
          
          console.log("Results elements:", { 
            newResultsContent: newResultsContent?.id, 
            currentResultsContent: currentResultsContent?.id 
          })

          if (newResultsContent && currentResultsContent) {
            console.log("Updating results content")
            currentResultsContent.innerHTML = newResultsContent.innerHTML
          }

          // Update map if it exists
          const mapElement = document.querySelector('#map')
          if (mapElement) {
            const mapController = this.application.getControllerForElementAndIdentifier(mapElement, 'map')
            if (mapController) {
              // Extract locations from the new HTML
              const newMapElement = doc.querySelector('#map')
              if (newMapElement) {
                const newLocations = JSON.parse(newMapElement.dataset.mapLocationsValue || '[]')
                // Update locations and reinitialize map
                mapController.locationsValue = newLocations
                mapController.initializeMap()
              }
            }
          }

          // Update active filters
          const newActiveFilters = doc.querySelector('.active-filters')
          const currentActiveFilters = document.querySelector('.active-filters')
          console.log("Active filters elements:", {
            newActiveFilters: newActiveFilters?.className,
            currentActiveFilters: currentActiveFilters?.className
          })
          
          if (newActiveFilters && currentActiveFilters) {
            console.log("Updating active filters")
            currentActiveFilters.innerHTML = newActiveFilters.innerHTML
          }

          // Hide mobile panel after applying filters on mobile
          if (window.innerWidth < 1024) {
            this.closeMobilePanel()
          }
        })
        .catch(error => {
          console.error('Error updating content:', error)
        })
      } else {
        console.warn("No form found in event target's parents")
      }
    }, 500)
  }
}
